import { Inject, Injectable } from '@angular/core';
import { CoreAuthConfig } from './core-auth.models';
import { CORE_AUTH_CONFIG } from './core-auth.tokens';

interface TokenPayload {
  key?: string;
  secret?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CoreAuthTokenService {
  constructor(@Inject(CORE_AUTH_CONFIG) private readonly config: CoreAuthConfig) {}

  getBearerToken(): string {
    const offlineToken = this.tryGetOfflineToken();
    if (offlineToken) {
      return offlineToken;
    }

    const keys = Object.keys(localStorage);
    const tokenKey = keys.find((item) => item.includes(`${this.config.msal.tenantName}.b2clogin.com-accesstoken`));

    if (!tokenKey) {
      return '';
    }

    const raw = localStorage.getItem(tokenKey);
    if (!raw) {
      return '';
    }

    try {
      const token = JSON.parse(raw) as TokenPayload;
      return token.secret || '';
    } catch {
      return '';
    }
  }

  private tryGetOfflineToken(): string {
    if (!this.config.offlineTokenStorageKey) {
      return '';
    }

    const raw = localStorage.getItem(this.config.offlineTokenStorageKey);
    if (!raw) {
      return '';
    }

    try {
      const token = JSON.parse(raw) as TokenPayload;
      return token.key || '';
    } catch {
      return '';
    }
  }
}
